import * as React from 'react'
import {H1} from '@frontrow/console/src/components/typography'
import {fromMaybe} from '@freckle/maybe'
import {SpinnerOverlay} from '@frontrow/console/src/components/spinner'

import {type SchoolAttrs} from '@frontrow/console/src/models/school'
import {type FilterT} from '@frontrow/console/src/components/common/data-table'
import {SchoolsDataTableContainer} from '@frontrow/console/src/components/pages/schools-page/schools-data-table'
import ErrorAlert from '@frontrow/console/src/components/common/error-alert'
import SchoolProfile from '@frontrow/console/src/components/pages/schools-page/school-profile'
import * as style from './schools-page.module.scss'

type Props = {
  defaultFiltered: Array<FilterT>
  isLoading: boolean
  newSchool: SchoolAttrs | undefined | null
  error: string | undefined | null
}

export default function SchoolsPage(props: Props): React.ReactElement {
  const {isLoading, newSchool: mNewSchool, error, defaultFiltered} = props

  const newSchool = fromMaybe(() => null, mNewSchool)

  const errors = error !== null && error !== undefined ? <ErrorAlert>{error}</ErrorAlert> : null

  const newSchoolProfile =
    newSchool !== null && newSchool !== undefined ? (
      <div className={style.newSchoolContainer}>
        Successfully created school
        <SchoolProfile school={newSchool} />
      </div>
    ) : null

  const body = isLoading ? (
    <SpinnerOverlay />
  ) : (
    <React.Fragment>
      <SchoolsDataTableContainer defaultFiltered={defaultFiltered} />
    </React.Fragment>
  )

  return (
    <div className={style.schoolsPageContainer}>
      <H1>Schools</H1>
      {errors}
      {newSchoolProfile}
      {body}
    </div>
  )
}
